import { designDistributor } from "../distributor";
import { UniversalGuide } from "./universal-guide";
import PillarsGuide from "./pillars-guide";

export const Guide = designDistributor({
	pillars: PillarsGuide,
	universal: UniversalGuide,
});
